export const yogaDetails = {

  1: {
    name: "ARDHACAKRASANA",
    english: "Half Wheel Pose",
    steps: [
      "Stand upright with feet together and arms by your sides.",
      "Place your palms on your lower back for support.",
      "Inhale deeply and slowly bend backward from the waist.",
      "Keep your knees straight and chest lifted.",
      "Hold for 10–20 seconds while breathing normally, then return slowly."
    ],
    benefits: "Improves spinal flexibility, strengthens back muscles, reduces stiffness.",
    precautions: "Avoid if suffering from severe back injury, vertigo, or dizziness."
  },

  2: {
    name: "BHUJANGASANA",
    english: "Cobra Pose",
    steps: [
      "Lie flat on your stomach with legs extended.",
      "Place palms beside your chest.",
      "Inhale and slowly raise your chest upward.",
      "Keep elbows slightly bent and shoulders relaxed.",
      "Hold for 15–20 seconds and release gently."
    ],
    benefits: "Strengthens spine, improves posture, enhances lung capacity.",
    precautions: "Avoid during pregnancy or severe lower back injury."
  },

  3: {
    name: "CHAKRASANA",
    english: "Wheel Pose",
    steps: [
      "Lie on your back with knees bent.",
      "Place palms beside ears with fingers pointing toward shoulders.",
      "Inhale and lift your body upward forming an arch.",
      "Straighten arms and legs as much as possible.",
      "Hold briefly and lower slowly."
    ],
    benefits: "Improves flexibility, strengthens arms and legs, energizes body.",
    precautions: "Avoid if suffering from heart problems or severe back pain."
  },

  4: {
    name: "DHANURASANA",
    english: "Bow Pose",
    steps: [
      "Lie on your stomach.",
      "Bend knees and hold ankles with hands.",
      "Inhale and lift chest and legs simultaneously.",
      "Balance on abdomen.",
      "Hold for 15 seconds and release gently."
    ],
    benefits: "Strengthens back, improves digestion, enhances posture.",
    precautions: "Avoid in case of hernia or severe back issues."
  },

  5: {
    name: "ARDHA HALASANA",
    english: "Half Plough Pose",
    steps: [
      "Lie flat on your back.",
      "Raise legs to 90 degrees slowly.",
      "Support hips with hands if needed.",
      "Keep legs straight.",
      "Hold briefly before lowering slowly."
    ],
    benefits: "Improves digestion and strengthens abdominal muscles.",
    precautions: "Avoid if neck injury exists."
  },

  6: {
    name: "HALASANA",
    english: "Plough Pose",
    steps: [
      "Lie on your back.",
      "Lift legs over head slowly.",
      "Try to touch toes to floor.",
      "Keep hands flat on ground.",
      "Hold briefly and release slowly."
    ],
    benefits: "Improves flexibility and stimulates abdominal organs.",
    precautions: "Avoid cervical spine problems."
  },

  7: {
    name: "MATSYASANA",
    english: "Fish Pose",
    steps: [
      "Lie flat on your back.",
      "Arch chest upward.",
      "Rest crown of head lightly on floor.",
      "Keep chest lifted.",
      "Hold and breathe normally."
    ],
    benefits: "Improves lung capacity and relieves fatigue.",
    precautions: "Avoid severe neck injury."
  },

  8: {
    name: "NATARAJASANA",
    english: "Lord of the Dance Pose",
    steps: [
      "Stand straight.",
      "Lift one leg backward.",
      "Hold foot with same side hand.",
      "Extend opposite arm forward.",
      "Balance and hold."
    ],
    benefits: "Improves balance, strengthens legs and core.",
    precautions: "Avoid knee or ankle injury."
  },

  9: {
    name: "PASCHIMOTTANASANA",
    english: "Seated Forward Bend",
    steps: [
      "Sit with legs extended forward.",
      "Inhale and raise arms.",
      "Exhale and bend forward.",
      "Try to touch toes.",
      "Hold position."
    ],
    benefits: "Improves digestion and stretches spine.",
    precautions: "Avoid severe back pain."
  },

  10: {
    name: "SALABHASANA",
    english: "Locust Pose",
    steps: [
      "Lie on stomach.",
      "Place hands under thighs.",
      "Lift legs upward.",
      "Hold briefly.",
      "Lower slowly."
    ],
    benefits: "Strengthens lower back and legs.",
    precautions: "Avoid severe lower back injury."
  },

  11: {
    name: "SARVANGASANA",
    english: "Shoulder Stand",
    steps: [
      "Lie on back.",
      "Lift legs upward.",
      "Support waist with hands.",
      "Keep body straight.",
      "Hold and breathe."
    ],
    benefits: "Improves blood circulation and thyroid function.",
    precautions: "Avoid neck injury or high blood pressure."
  },

  12: {
    name: "SASANKASANA",
    english: "Rabbit Pose",
    steps: [
      "Sit in Vajrasana.",
      "Bend forward.",
      "Rest forehead on floor.",
      "Stretch arms forward.",
      "Hold calmly."
    ],
    benefits: "Relieves stress and calms the mind.",
    precautions: "Avoid severe knee pain."
  },

  13: {
    name: "SIRSASANA",
    english: "Headstand",
    steps: [
      "Kneel down.",
      "Place head on floor.",
      "Lift legs upward.",
      "Balance body straight.",
      "Hold carefully."
    ],
    benefits: "Improves blood flow to brain.",
    precautions: "Avoid if high blood pressure or neck injury."
  },

  14: {
    name: "TRIKONASANA",
    english: "Triangle Pose",
    steps: [
      "Stand straight.",
      "Spread legs apart.",
      "Bend sideways.",
      "Touch ankle.",
      "Hold briefly."
    ],
    benefits: "Strengthens legs and improves balance.",
    precautions: "Avoid severe back injury."
  },

  15: {
    name: "USHTRASANA",
    english: "Camel Pose",
    steps: [
      "Kneel down.",
      "Arch backward.",
      "Hold heels with hands.",
      "Push hips forward.",
      "Hold briefly."
    ],
    benefits: "Improves posture and chest expansion.",
    precautions: "Avoid severe back pain."
  },

  16: {
    name: "VAJRASANA",
    english: "Thunderbolt Pose",
    steps: [
      "Sit on heels.",
      "Keep spine straight.",
      "Place palms on thighs.",
      "Breathe normally.",
      "Hold comfortably."
    ],
    benefits: "Improves digestion and posture.",
    precautions: "Avoid severe knee pain."
  },

  17: {
    name: "SIDDHASANA",
    english: "Accomplished Pose",
    steps: [
      "Sit cross-legged.",
      "Place one heel near perineum.",
      "Keep spine straight.",
      "Rest hands on knees.",
      "Meditate calmly."
    ],
    benefits: "Improves concentration and meditation posture.",
    precautions: "Avoid knee discomfort."
  },

  18: {
    name: "GOMUKHASANA",
    english: "Cow Face Pose",
    steps: [
      "Sit with legs folded.",
      "Stack knees.",
      "Hold opposite hands behind back.",
      "Keep spine straight.",
      "Hold position."
    ],
    benefits: "Improves shoulder flexibility.",
    precautions: "Avoid shoulder injury."
  },

  19: {
    name: "SIMHASANA",
    english: "Lion Pose",
    steps: [
      "Sit in Vajrasana.",
      "Place palms on knees.",
      "Open mouth wide.",
      "Stick tongue out.",
      "Roar gently."
    ],
    benefits: "Improves throat health and reduces stress.",
    precautions: "Avoid throat infection."
  },

  20: {
    name: "PADMASANA",
    english: "Lotus Pose",
    steps: [
      "Sit cross-legged.",
      "Place each foot on opposite thigh.",
      "Keep spine straight.",
      "Rest hands on knees.",
      "Breathe deeply."
    ],
    benefits: "Improves meditation posture.",
    precautions: "Avoid knee injury."
  },

  21: {
    name: "TADASANA",
    english: "Mountain Pose",
    steps: [
      "Stand straight with feet together.",
      "Raise arms overhead.",
      "Stretch upward.",
      "Lift heels slightly.",
      "Hold briefly."
    ],
    benefits: "Improves posture and balance.",
    precautions: "Avoid balance issues."
  },

  22: {
    name: "VRIKSHASANA",
    english: "Tree Pose",
    steps: [
      "Stand straight.",
      "Lift one foot onto inner thigh.",
      "Balance on one leg.",
      "Join palms above head.",
      "Hold and breathe."
    ],
    benefits: "Improves balance and concentration.",
    precautions: "Avoid knee injury."
  },

  23: {
    name: "UTTANPADASANA",
    english: "Raised Leg Pose",
    steps: [
      "Lie on back.",
      "Lift legs to 45 degrees.",
      "Keep hands by side.",
      "Hold briefly.",
      "Lower slowly."
    ],
    benefits: "Strengthens abdominal muscles.",
    precautions: "Avoid lower back injury."
  },

  24: {
    name: "SETU BANDHA SARVANGASANA",
    english: "Bridge Pose",
    steps: [
      "Lie on back.",
      "Bend knees.",
      "Lift hips upward.",
      "Keep shoulders grounded.",
      "Hold briefly."
    ],
    benefits: "Strengthens back and glutes.",
    precautions: "Avoid neck injury."
  },

  25: {
    name: "MAKARASANA",
    english: "Crocodile Pose",
    steps: [
      "Lie on stomach.",
      "Rest chin on palms.",
      "Relax body.",
      "Breathe normally.",
      "Hold comfortably."
    ],
    benefits: "Relaxes body and reduces stress.",
    precautions: "Safe for most people."
  },

  26: {
    name: "PARVATASANA",
    english: "Mountain Stretch / Downward Dog",
    steps: [
      "Sit cross-legged.",
      "Raise arms overhead.",
      "Join palms.",
      "Stretch upward.",
      "Hold briefly."
    ],
    benefits: "Improves posture and stretches spine.",
    precautions: "Avoid shoulder injury."
  },

  27: {
    name: "BAKASANA",
    english: "Crow Pose",
    steps: [
      "Squat down.",
      "Place palms on floor.",
      "Lift body balancing on hands.",
      "Keep knees on arms.",
      "Hold briefly."
    ],
    benefits: "Strengthens arms and wrists.",
    precautions: "Avoid wrist injury."
  },

  28: {
    name: "KAPALBHATI",
    english: "Skull Shining Breathing",
    steps: [
      "Sit comfortably.",
      "Exhale forcefully through nose.",
      "Inhale passively.",
      "Repeat rhythmically.",
      "Continue for 1 minute."
    ],
    benefits: "Improves lung capacity and detoxifies body.",
    precautions: "Avoid high blood pressure."
  },

  29: {
    name: "ANULOM VILOM",
    english: "Alternate Nostril Breathing",
    steps: [
      "Sit comfortably.",
      "Close right nostril.",
      "Inhale through left.",
      "Switch nostrils.",
      "Repeat slowly."
    ],
    benefits: "Calms mind and reduces anxiety.",
    precautions: "Safe for most people."
  },

  30: {
    name: "BHRAMARI",
    english: "Bee Breathing",
    steps: [
      "Sit comfortably.",
      "Close ears lightly.",
      "Inhale deeply.",
      "Exhale making humming sound.",
      "Repeat 5 times."
    ],
    benefits: "Reduces stress and improves concentration.",
    precautions: "Safe for most people."
  },

  31: {
    name: "SURYA NAMASKAR",
    english: "Sun Salutation",
    steps: [
      "Stand straight.",
      "Perform 12-step sequence.",
      "Synchronize breathing.",
      "Repeat 5 cycles."
    ],
    benefits: "Full body workout improving flexibility and stamina.",
    precautions: "Avoid if severe heart condition."
  },

  32: {
    name: "SHAVASANA",
    english: "Corpse Pose",
    steps: [
      "Lie flat on back.",
      "Keep arms relaxed.",
      "Close eyes.",
      "Breathe slowly.",
      "Relax fully."
    ],
    benefits: "Relieves stress and fatigue.",
    precautions: "Safe for all."
  }

};